import {
  EXCLUDE_ACTIVE_SQUAD,
  EXCLUDE_COMPLETED_EVOLUTIONS,
  EXCLUDE_PAID_EVOLUTIONS,
  PLAYERS_FROM,
  UNTRADEABLE_ONLY,
} from "../../../settings";
import axios from "../../privateApi";

export const logout = () => {
  return axios
    .post("/auth/logout")
    .then((_) => {
      removeUserFromLocalStorage();
    })
    .catch((_) => {
      removeUserFromLocalStorage();
    });
};

export const removeUserFromLocalStorage = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("name");
  localStorage.removeItem("email");
  localStorage.removeItem("paid");
  localStorage.removeItem("canUseClubImport");
  localStorage.removeItem("loggedIn");
  localStorage.removeItem("subscription");
  localStorage.removeItem(UNTRADEABLE_ONLY);
  localStorage.removeItem(PLAYERS_FROM);
  localStorage.removeItem(EXCLUDE_ACTIVE_SQUAD);
  localStorage.removeItem(EXCLUDE_PAID_EVOLUTIONS);
  localStorage.removeItem(EXCLUDE_COMPLETED_EVOLUTIONS);
};
